export const ABOUT_US_QUERY = `AboutUs {  
    aboutUses{
      data {
        id
        attributes {
          label
          title
          description
          description2
          header_image {
            data {
              attributes {
                name
                url
              }
            }
          }
          story_image {
            data {
              attributes {
                name
                url
              }
            }
          }
        }
      }
    }
  }`;
